import Cookie from '../services/cookie';
import store from '../store';
import moment from 'moment';
import { get, isEmpty } from 'lodash';
import { CA_fieldPatterns } from './cbsaFieldpatterns';
import { GB_fieldPatterns } from './c88FieldPatterns';
import { paramyToDisclaimCodes } from '../CBP_App/formSections/pga/disclaimCodes';
import _ from 'lodash';
import i18n from "i18next";

import { Icon, Popup } from 'semantic-ui-react';
import { checkCountryStateMapping } from '../CBSA_App/reducer/FormValidationReducer';

const getFieldPattern = (country) => {
  switch (country || window.shipmentCountry) {
    case 'GB':
      return GB_fieldPatterns;
    case 'CA':
      return CA_fieldPatterns;
  }
};

const getCookie = (cname) => {
  if (!cname) cname = window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN;
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

const logout = () => {
  console.log('logout: ', document.cookie);
  Cookie.del(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN);
  Cookie.del('kxEntrySummaryToken');
  localStorage.removeItem('i18nextLng');
  localStorage.removeItem("expandIsfFormWidthb");
  let targetOrigin = "*";
  let message = "Expired Token";
  window.parent.postMessage(message, targetOrigin);

  window.location.reload(true);
};

const onInactive = (ms, cb) => {
  var wait = setTimeout(cb, ms);
  document.onmousemove = document.mousedown = document.mouseup = document.onkeydown = document.onkeyup = document.focus = function () {
    clearTimeout(wait);
    wait = setTimeout(cb, ms);
  };
};

const splitAddress = (elem) => {
  let arr = elem.split(' ');
  let num = arr[0];
  arr.splice(0, 1);
  arr = arr.join(' ');
  return [num, arr];
};

// Takes an array of inputs to check for validity
const checkInvalidInputs = (inputs) => {
  let returnArray = {}; // Array to return
  let defaultMin = 2; // Default minimum for field inputs

  inputs.forEach((input) => {
    let keys = Object.keys(input);
    if (input === null || !input)
      returnArray[keys[0]] = {
        value: keys[0],
        error: true,
        message: 'Field cannot be empty',
      };
    // If input empty or null, set as false
    else {
      // If input is not empty
      if (input.min && input[keys[0]].length < input.min) {
        // If input provided its own min
        returnArray[keys[0]] = {
          value: keys[0],
          error: true,
          message: 'Must have at least ' + input.min + ' characters',
        }; // If input didn't meet the required length
      } else {
        if (input[keys[0]].length < defaultMin) {
          // If input didn't provided its own min
          returnArray[keys[0]] = {
            value: keys[0],
            error: true,
            message: 'Must have at least 2 characters',
          }; // If input didn't meet the min length required
        }
      }
    }
  });

  return returnArray;
};

const decamelize = (str, separator) => {
  separator = typeof separator === 'undefined' ? ' ' : separator;
  return _.startCase(str)
    .replace(/([a-z\d])([A-Z])/g, '$1' + separator + '$2')
    .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + separator + '$2');
};

const currencySymbolConverter = (countryName) => {
  if (countryName === 'US' || countryName === 'UNITED_STATES') {
    return '$';
  } else if (countryName === 'CA' || countryName === 'CANADA') {
    return 'C$';
  } else if (countryName === 'GB') {
    let pound = '£';
    return pound;
  } else {
    return '$';
  }
};
const formatMoney = (num) => {
  if (typeof num == "string" && /^\-?[\d]+(\.\d+)$/.test(num)) {
    num = parseFloat(num).toFixed(2)
  }
  let dollaredandcommaed =
    '$' + num &&
    !isEmpty(num) &&
    num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  if (
    dollaredandcommaed.split('.').length == 2 &&
    dollaredandcommaed.split('.')[1].length == 1
  )
    dollaredandcommaed += '0';
  return dollaredandcommaed;
};

const formatPronoun = (str) => {
  return str.replace(/(^\w{1})|(\s{1}\w{1})/g, (match) => match.toUpperCase());
};

const getTabName = () => {
  let docTypes = [...store.getState().searchContext.docTypes];
  let docCount = new Array(docTypes.length).fill(0);
  let misc = 0;
  const setName = (type, doc, format) => {
    try {
      if (type) {
        let docType = docTypes.filter((doc) => doc.name === type);
        let docTypeIndex = docTypes.indexOf(docType[0]);
        docCount[docTypeIndex]++;
        if (format === 'long') {
          return `${docType[0].longLabel} ${docCount[docTypeIndex]}`;
        } else {
          return docType[0].shortLabel === 'PRT'
            ? `${doc.displayName || docType[0].shortLabel}`
            : `${docType[0].shortLabel === 'HMRC REPORT'
              ? 'HMRC'
              : docType[0].shortLabel
            } ${docCount[docTypeIndex]}`;
        }
      } else {
        misc++;
        return `Misc ${misc > 1 ? misc : ''}`;
      }
    } catch (e) {
      console.error('GET_DOCUMENT_TYPES Failed');
      misc++;
      return `Misc ${misc > 1 ? misc : ''}`;
    }
  };
  return setName;
};

const getJobWheels = (shipmentCountry, currentJobData) => {
  let countryCode = shipmentCountry === 'GB' ? 'UK' : shipmentCountry;
  let ESEA = shipmentCountry === 'CA' ? 'EA' : 'ES';


  //search_shipments_broker buttons!
  // This condition Will be removed once UK workflow will be implemented
  ESEA = shipmentCountry === 'GB' ? 'ENTRY' : ESEA;

  const BROKER_PROCESS =
    !isEmpty(currentJobData) &&
    get(currentJobData, 'states.states', []).find((item) => {
      return item?.key === `SHIPMENT_BROKER_PROCESS`;
    });

  const ISF_JOB_WHEEL =
    !isEmpty(currentJobData) &&
    get(currentJobData, 'states.states', []).find((item) => {
      return item.key === `SHIPMENT_${countryCode}_ISF_PROCESS`;
    });
  const ES_JOB_WHEEL =
    !isEmpty(currentJobData) &&
    get(currentJobData, 'states.states', []).find((item) => {
      return item.key === `SHIPMENT_${countryCode}_${ESEA}_PROCESS`;
    });
  const CR_JOB_WHEEL =
    !isEmpty(currentJobData) &&
    get(currentJobData, 'states.states', []).find((item) => {
      return item.key === `SHIPMENT_${countryCode}_CR_PROCESS`;
    });
  const DIS_JOB_WHEEL =
    !isEmpty(currentJobData) &&
    get(currentJobData, 'states.states', []).find((item) => {
      return item.key === `SHIPMENT_DIS_PROCESS`;
    });
  const RNS_JOB_WHEEL =
    !isEmpty(currentJobData) &&
    get(currentJobData, 'states.states', []).find((item) => {
      return item.key === `SHIPMENT_RNS_PROCESS`;
    });
  const PSC_JOB_WHEEL =
    !isEmpty(currentJobData) &&
    get(currentJobData, 'states.states', []).find((item) => {
      return item.key === `SHIPMENT_PSC_PROCESS`;
    });
  const SHIPMENT_BROKER_HOUSE_PROCESS =
    !isEmpty(currentJobData) &&
    get(currentJobData, 'states.states', []).find((item) => {
      return item.key === `SHIPMENT_BROKER_HOUSE_PROCESS`;
    });
  const TRANSIT_JOB_WHEEL =
    !isEmpty(currentJobData) &&
    get(currentJobData, 'states.states', []).find((item) => {
      return item.key === `SHIPMENT_TRANSIT_PROCESS`;
    });

  const NCTS_JOB_WHEEL =
    !isEmpty(currentJobData) &&
    get(currentJobData, 'states.states', []).find((item) => {
      return item.key === `SHIPMENT_NCTS_PROCESS`;
    });
  const SHIPMENT_US_PGA_PROCESS =
    !isEmpty(currentJobData) &&
    get(currentJobData, 'states.states', []).find((item) => {
      return item.key === `SHIPMENT_US_PGA_PROCESS`;
    });

  const SHIPMENT_ENTRY_PROCESS =
    !isEmpty(currentJobData) &&
    get(currentJobData, 'states.states', []).find((item) => {
      return item.key === `SHIPMENT_ENTRY_PROCESS`;
    });

  const SHIPMENT_ES_PROCESS =
    !isEmpty(currentJobData) &&
    get(currentJobData, 'states.states', []).find((item) => {
      return item.key === `SHIPMENT_ES_PROCESS`;
    });

  const SHIPMENT_GB_PROCESS =
    !isEmpty(currentJobData) &&
    get(currentJobData, 'states.states', []).find((item) => {
      return item.key === `SHIPMENT_UK_CDS_PROCESS`;
    });

  const SHIPMENT_NL_PROCESS =
    !isEmpty(currentJobData) &&
    get(currentJobData, 'states.states', []).find((item) => {
      const formType = currentJobData?.formType
      const key = formType === 'DMS' ? 'SHIPMENT_NL_DMS_PROCESS' : 'SHIPMENT_NL_AGS_PROCESS'
      return (item.key === key);
    });


  const SHIPMENT_US_CW_PROCESS =
    !isEmpty(currentJobData) &&
    get(currentJobData, 'states.states', []).find((item) => {
      return item.key === `SHIPMENT_US_CW_PROCESS`;
    });

  const CUSTOM_RELEASE_PROCESS =
    !isEmpty(currentJobData) &&
    get(currentJobData, 'states.states', []).find((item) => {
      return item.key === `CUSTOM_RELEASE_PROCESS`;
    });

  const NL_DMS_CUSTOM_SUB_PROCESS =
    !isEmpty(currentJobData) &&
    get(currentJobData, 'states.states', []).find((item) => {
      return item.key === `SHIPMENT_NL_SUB_PROCESS`;
    });

    const ENTRY_TRANSACTION_STATUS = 
    !isEmpty(currentJobData) &&
    get(currentJobData, 'states.states', []).find((item) => {
      return item.key === `ENTRY_TRANSACTION_STATUS`;
    });

  return {
    ISF_JOB_WHEEL: ISF_JOB_WHEEL,
    ES_JOB_WHEEL: ES_JOB_WHEEL,
    CR_JOB_WHEEL: CR_JOB_WHEEL,
    DIS_JOB_WHEEL: DIS_JOB_WHEEL,
    RNS_JOB_WHEEL: RNS_JOB_WHEEL,
    BROKER_PROCESS: BROKER_PROCESS,
    PSC_JOB_WHEEL: PSC_JOB_WHEEL,
    CW_JOB_WHEEL: SHIPMENT_US_CW_PROCESS,
    SHIPMENT_BROKER_HOUSE_PROCESS: SHIPMENT_BROKER_HOUSE_PROCESS,
    TRANSIT_JOB_WHEEL: TRANSIT_JOB_WHEEL,
    NCTS_JOB_WHEEL: NCTS_JOB_WHEEL,
    SHIPMENT_US_PGA_PROCESS: SHIPMENT_US_PGA_PROCESS,
    ES_ENTRY_JOB_WHEEL: SHIPMENT_ENTRY_PROCESS, // common across all eu countries
    ES_CUSTOM_JOB_WHEEL: SHIPMENT_ES_PROCESS,
    GB_CUSTOM_JOB_WHEEL: SHIPMENT_GB_PROCESS,
    NL_CUSTOM_JOB_WHEEL: SHIPMENT_NL_PROCESS,
    NL_DMS_CUSTOM_SUB_PROCES_WHEEL: NL_DMS_CUSTOM_SUB_PROCESS, // DMS Subprocess
    CUSTOM_RELEASE_WHEEL: CUSTOM_RELEASE_PROCESS,
    //STATE_BH_ASSIGNED
    ENTRY_TRANSACTION_STATUS:ENTRY_TRANSACTION_STATUS,
  };
};

const disclaimCheckboxdisabledxf = (formType, hsDataDtl_paramy, parentvalue) => {
  if (_.get(parentvalue, 'disclaimFlag.value') === 'Y') return false;
  let disclaimcodes = paramyToDisclaimCodes(
    hsDataDtl_paramy,
    formType
  );
  if ((disclaimcodes || [].length) == 0) return true;
  return false;
};
const pgaDisabledCommonff = (parentprops, parentvalue) => {
  let isDisclaimed =
    parentvalue.disclaimFlag && parentvalue.disclaimFlag.value === 'Y';
  let hasDisclaimCode =
    parentvalue.disclaimCode && parentvalue.disclaimCode.value;
  if (isDisclaimed && !hasDisclaimCode) return true;
  return false;
};

const validatePgaField = (item) => {
  let error = [];
  if (!item) return error;
  if (!item.lengthClass && item.isOptional === 'Y') {
    return error;
  }
  let fieldName = (item.uiLabel + '').replaceAll('ndgredien', 'ngredien'); //fix some typos
  let lengthClass = item.lengthClass;
  let isMandatory = item.isOptional === 'N';
  let fieldValue = '';
  let regexx = item.regexx;
  let possibleDropdownValues = item.possibleDropdownValues;
  if (isNaN(item.value)) {
    fieldValue = (item.value || '').trim();
    if (
      item.PGAId === 'containerNum' &&
      item.value &&
      item.value.includes(';')
    ) {
      fieldValue = item.value.split(';')[1];
    }
  } else {
    fieldValue = item.value;
  }
  if ((fieldValue === '' || fieldValue == "_BLANK_") && isMandatory) {
    error.push(`${fieldName} is missing. (${item.key})`);
    return error;
  }
  let len = parseInt(lengthClass);
  if (len) {
    if (fieldValue.length > len) {
      error.push(
        `Length of ${fieldName} cannot be greater than ${len}. (${fieldValue}) (${item.key})`
      );
    }
    if (fieldValue && lengthClass.includes('AN')) {
      var format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      if (format.test(fieldValue)) {
        error.push(
          `${fieldName} should not contain special characters (${item.key})`
        );
      }
    } else if (fieldValue && lengthClass.includes('A')) {
      if (!/^[a-zA-Z]+$/.test(fieldValue)) {
        error.push(
          `${fieldName} should be alphabetic (A-Z) with no special character (${item.key})`
        );
      }
    } else if (fieldValue && lengthClass.includes('N')) {
      if (isNaN(fieldValue)) {
        error.push(`${fieldName} should be numeric. (${item.key})`);
      }
      if ((fieldValue + "").endsWith(".")) {
        error.push(`${fieldName} should be numeric. (${item.key})`);
      }
    }
  }
  if (regexx && !(fieldValue + '').match(regexx)) {
    error.push(
      `${fieldName} format isn't ${item.regexxdescription || ' a valid format'
      }. (${item.key})`
    );
  }
  if (fieldValue && fieldValue.length && possibleDropdownValues && possibleDropdownValues.length && !possibleDropdownValues.includes(fieldValue)) {
    error.push(
      `${fieldName} ${fieldValue} was not found in the list of ${item.possibleDropdownDescription || "dropdown values"} (${item.key})`
    );
  }

  if (fieldValue && fieldValue.length && item.forbiddenDropdownValues && item.forbiddenDropdownValues.includes(fieldValue)) {
    error.push(
      `${fieldName} ${fieldValue} is not allowed ${item.forbiddenDropdownValuesDescription} (${item.key})`
    );
  }

  return error;
};

const addErrorClass = (fieldId) => {
  try {
    const inputField =
      document.querySelector('#' + fieldId + window.shipmentId) ||
      document.querySelector('#' + fieldId);
    inputField.classList.add('errorInput');
  } catch (e) {
    //console.log(e);
  }
};

const removeErrorClass = (fieldId) => {
  try {
    const inputField =
      document.querySelector('#' + fieldId + window.shipmentId) ||
      document.querySelector('#' + fieldId);
    inputField.classList.remove('errorInput');
  } catch (e) {
    //console.log(e);
  }
};
//Pass level

const setupStructurePGAParentChild = (node) => {
  node.options = node.options || [{ key: 'ROOT' }];
  if (!node) return;
  let structure = {};
  for (var option of node.options) {
    structure[option.key] = {
      options_ahj: [],
      description: option.description,
    };
    if (node.childOptions) {
      for (let childoption of node.childOptions) {
        structure[option.key]['options_ahj'] = structure[option.key][
          'options_ahj'
        ].concat(childoption.options);
      }
    }
    for (let oneoption of structure[option.key].options_ahj) {
      oneoption.value = oneoption.key;
    }
    structure[option.key].options_ahj = structure[option.key].options_ahj.sort(
      (a, b) => (a.key > b.key ? 1 : -1)
    );
    structure[option.key].options_ahj = _.uniqBy(
      structure[option.key].options_ahj,
      'value'
    );
    if (node.childOptions) {
      for (let onenode of node.childOptions) {
        var structurerecr = setupStructurePGAParentChild(onenode);
        for (let onekey of Object.keys(structurerecr)) {
          structure[option.key][onekey] = structurerecr[onekey];
        }
      }
    }
  }
  return structure;
};

export const getValidationError = (
  field,
  value,
  Level,
  country,
  conditionValues
) => {
  if (value === '_BLANK_' || value == '-999' || value === 'PLEASE_CHOOSE_UOM') {
    value = '';
  }
  let fieldPatterns = getFieldPattern(country);
  if (!fieldPatterns) return [];
  let fieldDetails = fieldPatterns[Level][field];
  let errors = [];
  if (!fieldDetails) {
    return errors;
  }
  if (
    !value &&
    !fieldDetails?.optional &&
    !fieldDetails?.conditions &&
    !conditionValues
  ) {
    errors.push(`${fieldDetails?.fieldName} is mandatory`);
    return errors;
  }
  if (
    !value &&
    conditionValues &&
    !fieldDetails?.optional &&
    fieldDetails?.conditions
  ) {
    Object.entries(fieldDetails.conditions).forEach(([conditionName, v]) => {
      let valueToCheck = conditionValues[conditionName];
      if (field === 'amendmentReasonCode') {
        const isError = Object.entries(fieldDetails.conditions).every(([conditionName, v]) => {
          let valueToCheck = conditionValues[conditionName];
          if (!value && v === valueToCheck) {
            return true
          }
        })
        if (isError && !errors?.includes(`${fieldDetails?.fieldName} is mandatory`)) {
          errors.push(`${fieldDetails?.fieldName} is mandatory`);
        }
      } else if (Array.isArray(v)) {
        let checkSet = new Set(v);
        if (checkSet.has(valueToCheck))
          errors.push(`${fieldDetails?.fieldName} is mandatory`);
      } else if (!value && valueToCheck === v) {
        errors.push(`${fieldDetails?.fieldName} is mandatory`);
      }
    });
    return errors;
  }
  if (fieldDetails && (!fieldDetails.optional || value)) {
    if (field === 'consigneeeoriNumber' || field === 'consignereoriNumber') {
      if (value.length <= 4) {
        if (
          fieldDetails &&
          fieldDetails.pattern2 &&
          !fieldDetails.pattern2.test(value)
        ) {
          errors.push(
            fieldDetails.fieldName +
            ' can only contain ' +
            fieldDetails.description +
            ' characters'
          );
        }
      } else {
        if (
          fieldDetails &&
          !fieldDetails.pattern.test(value) &&
          !fieldDetails.pattern1.test(value)
        ) {
          errors.push(
            fieldDetails.fieldName +
            ' can only contain ' +
            fieldDetails.description +
            ' characters'
          );
        }
      }
    }
    else {
      if (fieldDetails && fieldDetails.pattern) {
        if (field === "vendorZip" && ["USA", "US"].includes(conditionValues?.vendorCountry)) {
          if (!/^(?:[0-9]{5})?$/.test(value)) {
            errors.push(
              fieldDetails.fieldName +
              ' can only contain ' +
              "0-9" +
              ' characters and length should be 5'
            );
          }
        }
        if (field === "vendorState" && ["USA", "US", 'CA'].includes(conditionValues?.vendorCountry)) {
          if (checkCountryStateMapping(conditionValues?.vendorCountry, value)) {
            errors.push(
              fieldDetails.fieldName +
              ` does not correspond to the selected country`
            );
          }
        }
        if (field === "quantity" && conditionValues && conditionValues == "Kilogram") {
          if (!/^\d+(\.\d{1,4})?$/.test(value)) {
            errors.push(
              fieldDetails.fieldName +
              ' can only contain floating point numbers till 4 decimal points'
            );
          }
        }
        else if (!fieldDetails.pattern.test(value)) {
          errors.push(
            fieldDetails.fieldName +
            ' can only contain ' +
            fieldDetails.description +
            ' characters'
          );
        }
      }
    }

    if (field === 'unitPrice') {
      if (!(Number(value) > 0)) {
        errors.push('Unit Price must be greater than 0');
      }
    }
    if (field === 'consigneeeoriNumber' || field === 'consignereoriNumber') {
      if (value.length === 4) {
      } else {
        if (
          value &&
          !isNaN(value) &&
          value.length !== undefined &&
          !(
            value.replace(/\./g, '').length >= fieldDetails.minLength &&
            value.replace(/\./g, '').length <= fieldDetails.maxLength
          )
        ) {
          let numberOdChars =
            fieldDetails.minLength === fieldDetails.maxLength
              ? fieldDetails.minLength
              : fieldDetails.minLength + ' to ' + fieldDetails.maxLength;
          errors.push(
            'Length of ' +
            fieldDetails.fieldName +
            ' should be ' +
            numberOdChars +
            '.' +
            ` (${value.replace(/\./g, '')})`
          );
        }
      }
    } else {
      if (
        value &&
        value.length !== undefined && (fieldDetails.minLength && fieldDetails.maxLength) &&
        !(
          value.replace(/\./g, '').length >= fieldDetails.minLength &&
          value.replace(/\./g, '').length <= fieldDetails.maxLength
        )
      ) {
        let numberOdChars =
          fieldDetails.minLength === fieldDetails.maxLength
            ? fieldDetails.minLength
            : fieldDetails.minLength + ' to ' + fieldDetails.maxLength;
        errors.push(
          'Length of ' +
          fieldDetails.fieldName +
          ' should be ' +
          numberOdChars +
          '.' +
          ` (${value.replace(/\./g, '')})`
        );
      }
    }
  }

  return errors;
};

const getInitials = (name) => {
  if (!name) {
    return '';
  }
  return name
    .split(/\s/)
    .reduce((response, word) => (response += word.slice(0, 1)), '')
    .toUpperCase();
};

export const shortDateFormatterV2 = (
  seconds,
  tz,
  card = false,
  invoice = false
) => {
  // console.log(385, "shortDateFormatterV2 :   ", seconds, tz);
  let time;
  const format = card ? 'MMM DD YYYY' : invoice ? 'MM/DD/YYYY' : 'LLL';
  if (tz) {
    if (tz.includes('/')) {
      time = moment.tz(seconds * 1000, tz).format(format);
    } else {
      const utcOffset = findUtcOffset(tz);
      if (utcOffset || utcOffset === 0) {
        time = moment.unix(seconds).utcOffset(utcOffset).format(format);
      } else {
        time = moment.unix(seconds).format(format);
      }
    }
  } else {
    time = moment.unix(seconds).format(format);
  }
  if (time === 'Invalid date') return null;
  // console.log(409, typeof time);
  return time;
};

export const shortDateFormatterV2WithoutTz = (seconds) => {
  // console.log("shortDateFormatterV2WithoutTz, Got time as ", seconds)
  const date = new Date(seconds);
  // console.log("Got date as ", date)

  const utcDate = Date.UTC(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  );
  // console.log("Got date as ", utcDate)

  return new Date(utcDate);
};

const findUtcOffset = (timezone) => {
  let s = timezone.substr(3); // Get rid of UTC, s= "+05:00"
  let sign = s[0]; // "+""
  let x = parseInt(s.substr(1, 2)) * 60 + parseInt(s.substr(4, 5));
  if (isNaN(x)) return null; //if timezone is formatted incorrectly, return null
  return parseInt(sign + x);
};

export const shortDateFormatterV2WithoutTzForCard = (seconds) => {
  // console.log("shortDateFormatterV2WithoutTz, Got time as ", seconds)
  let date = new Date(seconds);
  // console.log("Got date as ", date)

  let utcDate = Date.UTC(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  );

  let formattedDate = moment.unix(utcDate).format('MMM DD YYYY');
  // console.log("Got date as ", utcDate)

  return formattedDate;
};

const convertToTimezone = (arrivalDateUnfixed, destTimeZone) => {
  let arrivalDate = new Date(arrivalDateUnfixed);
  let newdate = arrivalDate;
  try {
    newdate = new Date(
      arrivalDate.toLocaleString('en-US', {
        timeZone: destTimeZone,
        year: 'numeric',
      }),
      arrivalDate.toLocaleString('en-US', {
        timeZone: destTimeZone,
        month: 'numeric',
      }) - 1,
      arrivalDate.toLocaleString('en-US', {
        timeZone: destTimeZone,
        day: 'numeric',
      }),
      arrivalDate.toLocaleString('en-US', {
        timeZone: destTimeZone,
        hour: 'numeric',
        hour12: false,
      }),
      arrivalDate.toLocaleString('en-US', {
        timeZone: destTimeZone,
        minute: 'numeric',
      }),
      arrivalDate.toLocaleString('en-US', {
        timeZone: destTimeZone,
        second: 'numeric',
      })
    );
  } catch (e) {
    console.error(`${Date.now} Warning, skipping invalid timezone ${destTimeZone}`)
  }
  return newdate;
};

export const normalizeData = (data, normalizeBy = 'id') => {
  let normalizedData = data.reduce((agg, item) => {
    agg[item[normalizeBy]] = item;
    return agg;
  }, {});

  const list = data.map((d) => d[normalizeBy]);

  return { normalizedData, list };
};

export const listOfWarehouseWithdrawlEntryTypes = ['31', '32', '34', '35', '36', '37', '38']; //https://www.bmsi.com/bmsi/doc/misc/camir/app_d.pdf

export const formatNormalizedErrors = ({ normalizedData, list }) => {
  let testItem = Object.values(normalizedData)[0] || {};
  // build merchandise/line-item errors
  if (testItem.merchandiseId && testItem.invoiceId) {
    return list.reduce((agg, fieldName) => {
      let curr = normalizedData[fieldName];
      let newField = { [fieldName]: [curr.msg] };
      if (agg?.[curr.invoiceId]?.[curr.merchandiseId]) {
        agg[curr.invoiceId][curr.merchandiseId] = {
          ...agg[curr.invoiceId][curr.merchandiseId],
          ...newField,
        };
      } else {
        agg[curr.invoiceId] = { [curr.merchandiseId]: { ...newField } };
      }
      return agg;
    }, {});
  }

  if (testItem.invoiceId) {
    // build invoice errors
    return list.reduce((agg, fieldName) => {
      let curr = normalizedData[fieldName];
      let newField = { [fieldName]: [curr.msg] };
      if (agg?.[curr.invoiceId]) {
        agg[curr.invoiceId] = { ...agg[curr.invoiceId], ...newField };
      } else {
        agg[curr.invoiceId] = newField;
      }
      return agg;
    }, {});
  }

  // build header errors
  return list.reduce((agg, fieldName) => {
    agg[fieldName] = [normalizedData[fieldName].msg];
    return agg;
  }, {});
};

const summaryIconName = {
  US: 'entrySummary',
  UK: 'c88Summary',
  CA: 'entryAccounting',
};
const userTypes = {
  freightForwarder: 'FREIGHT_FORWARDER',
  superFF: 'SUPER_FREIGHT_FORWARDER',
  customer: 'CUSTOMER_USER',
  apiCaller: 'API_CALLER_USER',
};

const selectedCircuit = (state) => {
  switch (state) {
    case 'green':
      return {
        color: 'green',
        icon: 'check circle',
        text: state,
      };
    case 'red':
      return {
        color: 'red',
        icon: ' times circle',
        text: state,
      };
    case 'yellow':
      return {
        color: '#d8ca07',
        icon: 'exclamation triangle',
        text: state,
      };
    case 'orange':
      return {
        color: 'orange',
        icon: 'exclamation triangle',
        text: state,
      };
    default:
      return {
        color: 'grey',
        icon: 'check circle',
        text: state,
      };
  }
};

export {
  getCookie,
  logout,
  onInactive,
  splitAddress,
  checkInvalidInputs,
  formatMoney,
  formatPronoun,
  getTabName,
  getJobWheels,
  validatePgaField,
  addErrorClass,
  removeErrorClass,
  setupStructurePGAParentChild,
  pgaDisabledCommonff,
  disclaimCheckboxdisabledxf,
  getInitials,
  userTypes,
  currencySymbolConverter,
  convertToTimezone,
  decamelize,
  selectedCircuit,
};
export const getDropDownText = (option) => {
  let displayText = option;
  if (option.value && option.desc) {
    // let lang = i18n.language || window.localStorage.i18nextLng || "en";
    // let textKey = lang!=="en" ? `text_${lang}`: `text`;

    displayText = option.value + ' - ' + option.desc
  }
  //   if (option.value && option[textKey]) {
  //   displayText = option.value + ' - ' + option[textKey]
  // } else if (option[textKey]) {
  //   displayText = option[textKey];

  else {
    displayText = option.value
  }

  if (typeof displayText === "string") {
    return displayText.replace(/_/g, " ");
  }
  return displayText;
};
export const isValidXml = (xmlString) => {
  var parser = new DOMParser();
  // attempt to parse the passed-in xml
  var dom = parser.parseFromString(xmlString, 'application/xml');
  if (dom.getElementsByTagName('parsererror').length > 0) {
    return false;
  }
  return true;
};

export const isLowerBrokerUiEnvironment = () => {
  const Env = window._env_.REACT_APP_BROKER_API_URL.match(
    /(stage[\.-]|staging|dev|qat)/g
  )
  // console.log("Current Env:", Env)
  return !!Env

}

export const getBrokerUiEnvironment = () => {
  let Env = window._env_.REACT_APP_BROKER_API_URL.match(
    /(stage[\.-]|staging|dev|qat|prod|pre-prod)/g 
  )
  // console.log("Current Env:", Env[0])
  if(Env?.length){
    return Env[0]
  }
  Env = window._env_.REACT_APP_BROKER_API_URL.match(/.*\/\/[^/]+\/([^/]+)\/.*/)
  if((Env?.length||0)>1){
    return Env[1]
  }
  alert("FAILED TO RECOGNIZE ENVIRONMENT!");
};

